module.exports = __webpack_public_path__ + "static/media/Music.330e5919.JPG";